export default function SiteFooter() {
  const zones = [
    { name: "社会热议", count: 3280 },
    { name: "消费维权", count: 2156 },
    { name: "职场吐槽", count: 1924 },
    { name: "综艺名场面", count: 1670 },
    { name: "品牌风波", count: 1408 },
    { name: "科技游戏圈", count: 1203 },
  ];
  const nav = ["今日热议榜", "分区合集", "争议焦点", "评论区切片", "实时短讯", "风向温度"];

  return (
    <footer className="bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-serif text-base font-black text-background-50">
                嘿
              </span>
              <span className="font-serif text-xl font-black text-foreground-950">51嘿料</span>
            </a>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-500">
              聚合网友观点、舆论风向与争议焦点，带你围观大家正在吵什么、又挺什么。
            </p>
          </div>

          <div>
            <p className="mb-3 text-sm font-semibold text-foreground-800">热议分区</p>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              {zones.map((z) => (
                <a key={z.name} href="#forums" className="text-xs text-foreground-500 hover:text-primary-600">
                  {z.name}
                  <span className="ml-1 text-foreground-300">{z.count}</span>
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="mb-3 text-sm font-semibold text-foreground-800">栏目导航</p>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              {nav.map((n, i) => {
                const href = ["#rank", "#forums", "#fights", "#clips", "#feed", "#pulse"][i];
                return (
                  <a key={n} href={href} className="text-xs text-foreground-500 hover:text-primary-600">
                    {n}
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row">
          <p className="text-xs text-foreground-400">
            © 2026 51嘿料 · 热议话题 / 评论区 / 网友观点与舆论风向 聚合站
          </p>
          <p className="text-xs text-foreground-400">
            内容仅为示例展示，观点不代表本平台立场
          </p>
        </div>
      </div>
    </footer>
  );
}